











































import { defineComponent, ref } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ButtonType } from '@getaccept/lib-ui';

import { SubscriptionConstants } from '../constants/subscription.constants';
import { SeatType } from '../types/seat-type';
import ModuleCard from './ModuleCard.vue';

export default defineComponent({
  components: { ModuleCard },
  setup() {
    const { tabs } = SubscriptionConstants;
    const selectedTab = ref(SeatType.Suite);

    return {
      t,
      ButtonType,
      tabs,
      selectedTab,
      SeatType,
    };
  },
});
